import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { DrawerHeader } from './drawer-header';
import { Image, View } from 'react-native';
import { partnerSupplier } from '@/utils/environment';

interface Props {
  hideShadow?: boolean;
  inInboundsStack?: boolean;
}

export const DrawerHeaderLarge: React.FC<Props> = ({
  hideShadow,
  inInboundsStack,
}) => {
  const [styles, theme] = useStyles();
  const logoUrl = theme.images.welcomeLogoUrl;

  const supplierName = partnerSupplier.fullName ?? '';

  return (
    <DrawerHeader
      DrawerLeftComponent={
        <View style={styles.logoWrapper}>
          <Image
            alt={supplierName}
            resizeMode="contain"
            source={{ uri: logoUrl }}
            style={styles.logoImage}
            testID="supplier-logo"
          />
        </View>
      }
      hideShadow={hideShadow}
      inInboundsStack={inInboundsStack}
      leftComponentStyle={styles.leftComponent}
    />
  );
};

const useStyles = createStyles((theme) => ({
  leftComponent: {
    backgroundColor: theme.colors.white,
  },
  logoImage: {
    flex: 1,
  },
  logoWrapper: {
    backgroundColor: theme.colors.white,
    flex: 1,
    padding: 6,
    width: 185,
  },
}));
